(function () {
  function initCarousel(root) {
    if (root.dataset.dtCarouselReady === 'true') return;
    var slides = Array.from(root.querySelectorAll('[data-dt-home-slide]'));
    var tabs = Array.from(root.querySelectorAll('[data-dt-home-to]'));
    if (slides.length < 2) return;

    root.dataset.dtCarouselReady = 'true';
    var current = 0;
    var timer = null;
    var hovered = false;
    var focused = false;
    var inView = true;
    var stoppedByUser = false;
    var autoplay = root.dataset.autoplay === 'true';
    var interval = Math.max(4000, Number(root.dataset.interval) || 7000);
    var count = root.querySelector('[data-dt-home-count]');
    var status = root.querySelector('[data-dt-home-status]');
    var play = root.querySelector('[data-dt-home-play]');
    var previous = root.querySelector('[data-dt-home-prev]');
    var next = root.querySelector('[data-dt-home-next]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function clearTimer() {
      if (timer !== null) window.clearTimeout(timer);
      timer = null;
    }

    function updatePlayLabel() {
      if (!play) return;
      var label = stoppedByUser ? play.dataset.playLabel : play.dataset.pauseLabel;
      play.textContent = label;
      play.setAttribute('aria-label', label);
    }

    function canAutoplay() {
      return autoplay && !stoppedByUser && !hovered && !focused && inView && !reducedMotion.matches && !document.hidden;
    }

    function schedule() {
      clearTimer();
      if (!canAutoplay()) return;
      timer = window.setTimeout(function () {
        show((current + 1) % slides.length, false);
      }, interval);
    }

    function show(index, fromUser) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var selected = slideIndex === current;
        slide.classList.toggle('is-active', selected);
        slide.inert = !selected;
        if (selected) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      tabs.forEach(function (tab, tabIndex) {
        var selected = tabIndex === current;
        tab.classList.toggle('is-active', selected);
        if (selected) tab.setAttribute('aria-current', 'true');
        else tab.removeAttribute('aria-current');
      });
      if (count) count.innerHTML = String(current + 1).padStart(2, '0') + ' <i>/</i> ' + String(slides.length).padStart(2, '0');
      if (fromUser) {
        stoppedByUser = true;
        if (status) status.textContent = slides[current].getAttribute('aria-label') || '';
      }
      updatePlayLabel();
      schedule();
    }

    function onPrevious() { show(current - 1, true); }
    function onNext() { show(current + 1, true); }
    function onPlay() { stoppedByUser = !stoppedByUser; updatePlayLabel(); schedule(); }
    function onPointerEnter() { hovered = true; clearTimer(); }
    function onPointerLeave() { hovered = false; schedule(); }
    function onFocusIn() { focused = true; clearTimer(); }
    function onFocusOut(event) {
      if (root.contains(event.relatedTarget)) return;
      focused = false;
      schedule();
    }
    function onVisibilityChange() { schedule(); }
    function onMotionChange() {
      if (play) play.hidden = reducedMotion.matches;
      schedule();
    }

    previous.addEventListener('click', onPrevious);
    next.addEventListener('click', onNext);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { show(Number(tab.dataset.dtHomeTo), true); });
    });
    if (play) play.addEventListener('click', onPlay);
    root.addEventListener('pointerenter', onPointerEnter);
    root.addEventListener('pointerleave', onPointerLeave);
    root.addEventListener('focusin', onFocusIn);
    root.addEventListener('focusout', onFocusOut);
    document.addEventListener('visibilitychange', onVisibilityChange);
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', onMotionChange);
    if (play) play.hidden = reducedMotion.matches;

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        schedule();
      }, { threshold: 0.3 });
      observer.observe(root);
    }

    root.dtCarouselCleanup = function () {
      clearTimer();
      if (observer) observer.disconnect();
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (reducedMotion.removeEventListener) reducedMotion.removeEventListener('change', onMotionChange);
      root.dataset.dtCarouselReady = 'false';
    };
    schedule();
  }

  function scan(scope) {
    if (scope.matches && scope.matches('[data-dt-home-carousel]')) initCarousel(scope);
    scope.querySelectorAll('[data-dt-home-carousel]').forEach(initCarousel);
  }

  function boot() {
    scan(document);
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-dt-home-carousel]').forEach(function (carousel) {
        if (carousel.dtCarouselCleanup) carousel.dtCarouselCleanup();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());
